<template>
<div class="mobileMovePage" id="">  
  <XR-head titleText="迁移手机号" :rightShow="false" ref="head"></XR-head>
  <div class="login-form">
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="手机号" icon=":fa fa-phone" labelFloat fullWidth disabled="true" v-model="bindInfo.mobile" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="70" tablet="75" desktop="33">
      <mu-text-field label="短信验证码" helpText="点击右侧按钮获取，3分钟内有效" icon=":fa fa-envelope-o" labelFloat fullWidth v-model="bindInfo.code" />
    </mu-col>
    <mu-col width="30" tablet="25" desktop="33">      
      <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="login-div">
      <mu-raised-button label="迁 移" class="demo-raised-button" primary fullWidth @click="submit()" />
     
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div2">
      <mu-sub-header>温馨提醒</mu-sub-header>
      <mu-content-block class="notice">您手机号绑定账号{{unBindUserName}}账号，现迁移绑定到此账号{{BindUserName}}上</mu-content-block>
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div3">
      <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
    </mu-col>
  </mu-row>
</div>
</div>
</template>
<script>
 
export default {
  data () {
    return {
      isTestPhone : false,
      isSms:false,
      bindInfo:{
        mobile :'',
        code:''
      },    
      unBindUserName: this.$route.query.userName,
      BindUserName:'',
      smsBtnText:'获取短信'
    }
  },
  mounted(){
    this.bindInfo.mobile =this.$route.query.mobile
    this.getMemberInfo()
  },
  methods: {
    getMemberInfo(){           
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false  
          ths.BindUserName = res.Data.user_name        
          ths.$refs.XRtoast.hide()
        }
      });      
    },
    submit: function () {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/MoveMobile",
        JSON.stringify(this.bindInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.$router.push('/usercenter/index')
        }
      });
    },
    getSmsCode: function(){
      var ths = this;   
        if(!ths.isSms){
          ths.$post(
            "/Shop/UserServer/MoveMobileSendSms",
            JSON.stringify(this.bindInfo)
          ).then(function(res) {
            ths.$refs.XRtoast.hide()
            if(!res.IsSuccess){
              ths.$refs.XRtoast.failed(res.Msg, true)
            }else{          
              ths.isSms = true;
              ths.smsBtnText = res.Data * 60;
              var interval = setInterval(function(){
                if(ths.smsBtnText >0){
                  ths.smsBtnText--
                  ths.isSms = true;
                }else{                  
                  ths.isSms = false;
                  ths.smsBtnText = '获取短信'
                  clearInterval(interval)
                }
              }, 1000)  
            }
        });
      }
    },
    goBack(){
      this.$router.goBack()
    }
  }
}

</script>
<style>
.mobileMovePage{
  background: white;
}
.mobileMovePage .login-form {
  padding: 10px 20px 20px 10px;
}
.mobileMovePage .login-div {
  padding: 40px 0px 0 20px;
}
.mobileMovePage .demo-raised-button {
  height: 50px;
}
.mobileMovePage .goBackBtn {
  margin-top: 10px;
}
.mobileMovePage .div2 {
  padding: 20px 0 0 0;
}
.mobileMovePage .demo-flat-button.right {
  float: right;
}
.mobileMovePage .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.mobileMovePage .mobileMovePage .notice{
  font-size: 12px;
}
.mobileMovePage .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/mobileMove.vue